import { colors } from './colors';

const white = colors.white;

export const semanticTheme = {
  light: {
    avatars: {
      default: colors.neutral[300],
      contrastText: colors.white,
    },
    surface: {
      bg1: white,
      bg2: colors.neutral[20],
      bg3: colors.neutral[50],

      hover: colors.neutral[50],
      active: colors.primary[100],

      primary: colors.primary[100],
      primary2: colors.primary[200],
      primary3: colors.info[100],

      success: colors.success[100],
      warning: colors.warning[100],
      error: colors.error[100],
      info: colors.info[100],
      violet: colors.violet[100],
      teal: colors.teal[100],
      amber: colors.amber[100],
      green: colors.green[100],
      blue: colors.info[100],
    },

    text: {
      title: colors.primary[700],
      title2: colors.neutral[800],
      title3: colors.primary[700],
      heading: colors.neutral[800],
      body: colors.neutral[600],
      secondary: colors.neutral[500],
      disabled: colors.neutral[300],
      support: colors.neutral[600],

      success: colors.success[500],
      warning: colors.warning[500],
      error: colors.error[500],
      error2: colors.error[600],
      info: colors.info[500],

      darkBlue: colors.darkBlue[4],
      violet: colors.violet[400],
    },

    metricText: {
      success: colors.success[600],
      violet: colors.violet[700],
      error: colors.error[600],
      warning: colors.warning[600],
      info: colors.info[600],
    },

    button: {
      primary: {
        background: colors.primary[700],
        hover: colors.primary[800],
        active: colors.primary[600],
        disabled: colors.primary[300],

        text: white,
      },

      secondary: {
        background: white,
        hover: colors.neutral[50],
        active: colors.primary[100],

        text: colors.neutral[600],
        border: colors.neutral[600],
        outline2: colors.neutral[200],
      },
      error: {
        background: colors.error[500],
        text: white,
        border: colors.error[500],
        hover: colors.error[600],
      },
      warning: {
        background: colors.warning[500],
        text: white,
        border: colors.warning[500],
        hover: colors.warning[600],
      },
    },

    stepper: {
      completed: colors.teal[700],
      warning: colors.warning[600],
      active: colors.primary[700],
      default: colors.grey[600],
      locked: colors.neutral[300],
      background: colors.neutral[600],
    },

    icon: {
      primary: colors.primary[700],
      default: colors.neutral[700],
      disabled: colors.neutral[300],
      active: colors.primary[700],

      accent: colors.accent[500],
      success: colors.success[600],
      warning: colors.warning[500],
      error: colors.error[500],
      violet: colors.violet[700],
      blue: colors.info[500],
      blueDark: colors.darkBlue[4],
      teal: colors.teal[600],
      amber: colors.amber[600],
      green: colors.green[600],
      darkBlue: colors.darkBlue[5],
    },

    outline: {
      primary: colors.primary[700],
      light: colors.neutral[400],
      medium: colors.neutral[600],
      dark: colors.neutral[700],
      warning: colors.warning[500],
      error: colors.error[500],
      amber: colors.amber[500],
      green: colors.green[500],
      blue: colors.info[500],
    },

    link: {
      default: colors.primary[700],
      hover: colors.primary[500],
      disabled: colors.neutral[300],
    },
    chip: {
      success: colors.success[200],
      warning: colors.warning[200],
      error: colors.error[200],
      info: colors.info[200],
      violet: colors.violet[200],
    },
    tags: {
      default: colors.info[100],
      border: colors.primary[700],
      iconBg: colors.primary[600],
      icon: white,
      hovered: colors.info[200],
    },
    card: {
      success: colors.success[100],
      warning: colors.amber[100],
      error: colors.error[100],
      info: colors.info[100],
      violet: colors.violet[100],
    },
    hyperlink: {
      active: colors.primary[600],
      hover: colors.primary[700],
      disabled: colors.neutral[400],
    },
    breadcrumbs: {
      label: {
        inactive: colors.neutral[500],
        default: colors.neutral[600],
        hover: colors.neutral[800],
        active: colors.primary[700],
      },
      outline: colors.neutral[800],
      arrow: colors.neutral[600],
    },
    upsellAds: {
      bg1: colors.primary[50],
      bg2: colors.accent[100],
      redBorder: colors.accent[500],
    },
    scrollbar: {
      default: {
        bg: colors.white,
        toggle: colors.neutral[400],
        hover: colors.neutral[500],
      },
      success: {
        bg: colors.white,
        toggle: colors.green[500],
        hover: colors.green[600],
      },
      warning: {
        bg: colors.white,
        toggle: colors.amber[500],
        hover: colors.amber[600],
      },
      error: {
        bg: colors.white,
        toggle: colors.error[500],
        hover: colors.error[600],
      },
      info: {
        bg: colors.white,
        toggle: colors.info[500],
        hover: colors.info[600],
      },
    },
    boxShadow: '#0000001F',
  },

  dark: {
    avatars: {
      default: colors.primary[600],
      contrastText: colors.white,
    },
    surface: {
      bg1: colors.darkBlue[8],
      bg2: colors.darkBlue[6],
      bg3: colors.darkBlue[7],

      hover: colors.primary[700],
      active: colors.primary[500],

      primary: colors.primary[100],
      primary2: colors.primary[200],
      primary3: colors.darkBlue[6],

      success: colors.success[200],
      warning: colors.warning[200],
      error: colors.error[200],
      info: colors.info[200],
      violet: colors.violet[200],
      // teal/amber/green matched violet's already-correct pattern (bg stays pale, one step up
      // from its light-mode value) per the Tile Library's dark-mode reference (Figma node
      // 4136:22480) - these three were the only ones that had jumped to a bold 700-level tone
      // instead, which is what made the Activity Logs/Master Scheduler/Recent Admin Actions tile
      // icon badges not match Figma in dark mode.
      teal: colors.teal[200],
      amber: colors.amber[200],
      green: colors.green[200],
      blue: colors.info[100],
    },

    text: {
      title: white,
      title2: white,
      title3: colors.info[400],
      heading: white,
      body: white,
      secondary: colors.neutral[200],
      disabled: colors.neutral[300],
      support: colors.neutral[200],

      success: colors.success[600],
      warning: colors.warning[600],
      error: colors.error[600],
      error2: colors.error[400],
      info: colors.info[600],

      darkBlue: colors.darkBlue[5],
      violet: colors.violet[500],
    },

    metricText: {
      success: colors.success[600],
      violet: colors.violet[700],
      error: colors.error[600],
      // Darkened past the light-mode value (warning[600]) - warning[600] only reaches ~3.25:1
      // against the pale warning[200] pill background this token is used against in dark mode
      // (surface.warning), short of WCAG AA's 4.5:1 for normal text. warning[700] reaches ~4.7:1.
      warning: colors.warning[700],
      info: colors.info[600],
    },

    button: {
      primary: {
        background: colors.primary[600],
        hover: colors.primary[700],
        active: colors.primary[400],
        disabled: colors.primary[300],

        text: white,
      },

      secondary: {
        background: white,
        hover: colors.primary[700],
        active: colors.primary[400],

        text: white,
        border: white,
        outline2: white,
      },
      error: {
        background: colors.error[500],
        text: white,
        border: colors.error[500],
        hover: colors.error[600],
      },
      warning: {
        background: colors.warning[500],
        text: white,
        border: colors.warning[500],
        hover: colors.warning[600],
      },
    },

    stepper: {
      completed: colors.teal[400],
      warning: colors.warning[400],
      active: colors.info[400],
      default: colors.grey[400],
      locked: colors.neutral[300],
      background: colors.neutral[200],
    },

    icon: {
      primary: white,
      default: white,
      disabled: colors.neutral[300],
      active: colors.info[400],

      success: colors.success[400],
      warning: colors.warning[400],
      error: colors.error[400],
      violet: colors.violet[700],
      blue: colors.info[700],
      blueDark: colors.darkBlue[4],
      accent: colors.accent[500],
      // Matched to their light-mode value (same pairing violet already used) now that their
      // background went pale instead of bold - a pale icon glyph on the now-also-pale background
      // above would have been nearly invisible.
      teal: colors.teal[600],
      amber: colors.amber[600],
      green: colors.green[600],
      darkBlue: colors.darkBlue[5],
    },

    outline: {
      primary: white,
      light: colors.neutral[600],
      medium: colors.neutral[600],
      dark: colors.neutral[700],
      warning: colors.warning[400],
      // Darkened past error[400]/amber[400] - those were nearly invisible (~2:1 contrast)
      // against the pale error[200]/warning[200] pill backgrounds these outline the border of.
      error: colors.error[600],
      amber: colors.amber[700],
      green: colors.green[500],
      blue: colors.info[500],
    },

    link: {
      default: colors.primary[400],
      hover: colors.primary[600],
      disabled: colors.neutral[300],
    },
    chip: {
      success: colors.success[100],
      warning: colors.warning[100],
      error: colors.error[100],
      info: colors.info[100],
      violet: colors.violet[100],
    },
    tags: {
      default: colors.primary[600],
      border: white,
      iconBg: white,
      icon: colors.primary[600],
      hovered: colors.info[700],
    },
    card: {
      success: colors.success[200],
      warning: colors.amber[200],
      error: colors.error[200],
      info: colors.info[200],
      violet: colors.violet[200],
    },
    hyperlink: {
      active: colors.info[400],
      hover: colors.info[500],
      disabled: colors.neutral[400],
    },
    breadcrumbs: {
      label: {
        inactive: colors.neutral[300],
        default: colors.neutral[200],
        hover: colors.neutral[300],
        active: colors.white,
      },
      outline: colors.neutral[300],
      arrow: colors.neutral[300],
    },
    upsellAds: {
      bg1: colors.darkBlue[7],
      bg2: colors.darkBlue[7],
      redBorder: colors.accent[400],
    },
    scrollbar: {
      default: {
        bg: colors.darkBlue[5],
        toggle: colors.primary[600],
        hover: colors.primary[500],
      },
      success: {
        bg: colors.white,
        toggle: colors.green[500],
        hover: colors.green[600],
      },
      warning: {
        bg: colors.white,
        toggle: colors.amber[500],
        hover: colors.amber[600],
      },
      error: {
        bg: colors.white,
        toggle: colors.error[500],
        hover: colors.error[600],
      },
      info: {
        bg: colors.white,
        toggle: colors.info[500],
        hover: colors.info[600],
      },
    },
    boxShadow: '#0000001F',
  },
} as const;

export type SemanticTheme = typeof semanticTheme;
